import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPlaceLight = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 144,
	height: 144,
	viewBox: "0 0 144 144",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_place_light)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M17.9678 29.8252C17.8033 28.3614 18.7058 29.1632 18.7188 29.1748C21.4657 29.4258 21.0952 30.0503 20.2803 34.5977C19.4667 39.1465 18.1322 31.3004 17.9678 29.8252ZM7.49707 26.0273C8.63941 24.3081 9.0576 25.6096 9.05762 25.6094C9.06817 25.6176 9.38022 25.8657 10.2578 26.8955C11.1503 27.9429 9.00993 29.2903 7.36328 30.3115C5.71959 31.3304 5.06462 31.3915 5.49902 30.6113C5.93504 29.8293 6.35611 27.7457 7.49707 26.0273ZM25.1992 24.9795C25.8497 24.2132 26.4883 24.4697 26.4883 24.4697C29.4735 28.2554 25.9639 27.1481 25.0166 26.7549C24.0712 26.3616 24.5489 25.7448 25.1992 24.9795ZM15.9951 10.4971C17.7449 9.92139 22.4767 11.5583 24.1123 17.0674C25.7474 22.5769 21.8082 25.3852 17.3604 26.2041C12.9113 27.0229 9.58202 22.8278 9.2627 17.4395C8.94641 12.0725 15.9388 10.5096 15.9951 10.4971ZM4.25879 16.3311C5.83557 16.4002 5.10286 18.0072 5.02344 19.1895C4.94248 20.3723 4.03572 20.0443 2.19141 19.3154C0.345975 18.5869 -0.743377 17.9131 0.59375 17.4707C1.92942 17.0294 3.72362 16.3079 4.25879 16.3311ZM26.835 17.291C26.7865 15.7166 28.1641 16.1406 28.1641 16.1406C37.3776 16.1527 33.6329 16.9668 30.0654 18.3369C26.4994 19.707 26.8853 18.8668 26.835 17.291ZM26.1113 6.99512C26.7674 6.75674 26.9362 7.19039 26.5615 7.51562C26.1853 7.84156 24.8702 10.2936 24.0498 11.5059C23.2293 12.717 22.084 10.9883 22.084 10.9883C20.1258 8.96002 26.0536 7.01402 26.1113 6.99512ZM3.71875 6.36328C3.0025 5.77089 5.66353 6.39908 7.71387 8.06152C7.72702 8.07576 9.32137 9.80403 8.62207 10.5098C7.92267 11.2181 6.77763 11.2993 6.04199 10.2168C5.30779 9.13362 4.43326 6.95693 3.71875 6.36328ZM10.3906 0.989258C9.73601 -1.98473 12.9866 2.58515 13.8613 3.74805C14.736 4.91235 15.0952 6.42228 12.918 7.2959C10.7523 8.16449 11.0635 5.1846 11.0664 5.15723C11.0664 5.15723 11.0439 3.96244 10.3906 0.989258Z",
				fill: "#8588D8"
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M65.3285 20.2313C65.7103 18.9158 67.3229 18.4489 68.3837 19.2553C69.6992 16.8791 73.5183 17.77 73.4759 20.6131C75.8098 20.5707 75.3006 24.3049 73.0515 23.6683C72.4573 24.8565 70.8873 25.0685 69.9536 24.1775C69.1474 25.7901 66.6861 25.493 66.3043 23.6683C62.7823 25.6627 61.5092 20.4858 65.3283 20.231L65.3285 20.2313Z",
				fill: "#8588D8"
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M134.312 36.781C133.704 34.6238 131.049 33.8492 129.334 35.2323C127.177 31.3603 120.926 32.7985 121.037 37.4447C117.165 37.3894 117.995 43.5291 121.701 42.4229C122.697 44.3589 124.964 44.7461 126.624 43.3631C126.79 43.5843 126.9 43.7503 127.066 43.9163C129.002 45.9628 132.764 44.9121 133.04 42.4228C134.644 43.5843 137.797 42.7548 137.853 39.9891C137.908 38.6064 136.193 36.6149 134.313 36.7809L134.312 36.781Z",
				fill: "#8588D8"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M22.3964 71.9517H36.3075C36.7216 71.9518 37.0575 72.2875 37.0575 72.7017V88.7388C37.0575 89.1529 36.7216 89.4886 36.3075 89.4888H22.3964C21.9821 89.4888 21.6464 89.153 21.6464 88.7388V72.7017C21.6464 72.2874 21.9821 71.9517 22.3964 71.9517Z",
				stroke: "#4F49BA",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M2.63965 84.75L29.6396 47.25L30.9742 49.1418L2.63965 88.0205V84.75Z",
				fill: "#8588D8"
			}),
			/* @__PURE__ */ _jsx("rect", {
				y: 142.5,
				width: 144,
				height: 1.5,
				fill: "black"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M10.6926 107.405H43.6887C44.1029 107.405 44.4387 107.741 44.4387 108.155V138.917C44.4387 139.331 44.1029 139.667 43.6887 139.667H10.6926C10.2784 139.667 9.94263 139.331 9.94263 138.917V108.155C9.94263 107.741 10.2784 107.405 10.6926 107.405Z",
				stroke: "#4F49BA",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M101.896 103.148H120.265C120.679 103.148 121.015 103.484 121.015 103.898V122.98C121.015 123.395 120.679 123.73 120.265 123.73H101.896C101.482 123.73 101.146 123.395 101.146 122.98V103.898C101.146 103.484 101.482 103.148 101.896 103.148Z",
				stroke: "#4F49BA",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M55.1397 83.2498L70.0235 67.5132L71.9661 69.4538L51.58 91.0776H48.5635C48.3016 91.0776 48.1655 90.7655 48.3436 90.5735L55.1397 83.2498Z",
				fill: "#8588D8"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M70.0234 67.5132H105.476L128.74 91.0776H93.6301L70.0234 67.5132Z",
				fill: "#8588D8"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M55.1396 83.25L29.6396 47.25H91.1396L105.476 67.5134H70.0235L55.1396 83.25Z",
				fill: "#8588D8"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M29.6396 47.25L2.781 84.5537C2.6891 84.6813 2.63965 84.8346 2.63965 84.9919V141.588C2.63965 142.002 2.97544 142.338 3.38965 142.338H51.111M29.6396 47.25L55.1396 83.25M29.6396 47.25H90.7515C90.995 47.25 91.2232 47.3681 91.3638 47.5668L105.476 67.5134M55.1396 83.25L70.0235 67.5134M55.1396 83.25L49.0452 89.8176C48.5998 90.2976 48.9402 91.0778 49.595 91.0778H50.8231C51.24 91.0778 51.5769 91.4178 51.5731 91.8346L51.111 142.338M105.476 67.5134H70.0235M105.476 67.5134L128.74 91.0778M70.0235 67.5134L93.6301 91.0778M51.111 142.338H55.7356M93.6301 142.338H127.99C128.405 142.338 128.74 142.002 128.74 141.588V91.0778M93.6301 142.338V132.918M93.6301 142.338H77.7445M93.6301 91.0778H128.74M93.6301 91.0778V132.918M55.7356 142.338V138.734C55.7356 138.319 56.0714 137.984 56.4856 137.984H61.1505M55.7356 142.338H77.7445M85.1681 132.918V137.234C85.1681 137.648 84.8323 137.984 84.4181 137.984H77.7445M85.1681 132.918H93.6301M85.1681 132.918H61.9005C61.4863 132.918 61.1505 133.254 61.1505 133.668V137.984M61.1505 137.984H77.7445M77.7445 137.984V142.338",
				stroke: "black",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M72.8462 105.403H84.5249C84.9389 105.403 85.2749 105.739 85.2749 106.153V132.135H72.0962V106.153C72.0962 105.739 72.432 105.403 72.8462 105.403Z",
				fill: "black",
				stroke: "black",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M87.4405 100.443H64.8155V100.621H65.087C65.4823 100.621 65.858 100.795 66.1143 101.096L69.4219 104.982C70.1678 105.859 69.5452 107.206 68.3946 107.207H67.2755L67.0196 111.112C66.973 111.822 66.3839 112.374 65.6729 112.374H62.6924C61.9814 112.374 61.3923 111.822 61.3458 111.112L61.0899 107.207H59.963C58.8082 107.207 58.1866 105.85 58.9405 104.976L62.2891 101.09L62.3907 100.984C62.6393 100.752 62.9688 100.621 63.3126 100.621H63.3155V100.293C63.3158 99.5477 63.9198 98.9435 64.6651 98.9434H87.4405V100.443ZM62.834 110.874H65.5323L65.7725 107.207H62.5938L62.834 110.874Z",
				fill: "black"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M112.87 129.867C115.313 129.867 117.358 131.576 117.878 133.864L118.105 134.86L118.988 134.346C119.615 133.98 120.345 133.77 121.126 133.77C123.4 133.77 125.257 135.555 125.371 137.801L125.376 138.02C125.376 139.164 124.922 140.2 124.184 140.966L123.974 141.184V142.269H106.878L102.344 142.176C101.611 141.553 101.146 140.631 101.146 139.6L101.151 139.425C101.242 137.635 102.722 136.211 104.535 136.211V136.212C105.344 136.212 106.086 136.496 106.669 136.971L108.391 138.37L107.873 136.214C107.78 135.828 107.731 135.424 107.731 135.008H107.73C107.73 132.258 109.89 130.012 112.605 129.874L112.87 129.867Z",
				fill: "black",
				stroke: "black",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M132.848 126.741C135.537 126.741 137.717 129.037 137.717 131.87V136.626C138.233 136.274 138.847 136.068 139.508 136.068C141.33 136.068 142.808 137.625 142.808 139.544C142.808 141.463 141.33 143.019 139.508 143.019H127.98V131.87C127.98 129.037 130.159 126.741 132.848 126.741Z",
				fill: "black"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M79.1798 39.8496H66.3514C65.523 39.8496 64.8514 40.5212 64.8514 41.3496V46.8054H72.7656L80.6798 56.5939V46.8054V41.3496C80.6798 40.5212 80.0082 39.8496 79.1798 39.8496Z",
				fill: "black"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M0 135.75C0 133.679 1.67893 132 3.75 132C5.82107 132 7.5 133.679 7.5 135.75V142.5H0V135.75Z",
				fill: "black"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M9 140.25C9 139.007 10.0074 138 11.25 138C12.4926 138 13.5 139.007 13.5 140.25V144H9V140.25Z",
				fill: "black"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_place_light",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 144,
			height: 144,
			fill: "white"
		})
	}) })]
});
export default SvgPlaceLight;
